import React from "react";
import MUIButton from "@mui/material/Button";
import type { CustomButtonProps } from "@components/Button/Button.types.ts";

const Button: React.FC<CustomButtonProps> = ({ testId, label, className, ...rest }) => {
  return (
    <MUIButton className={className} {...rest} {...(testId ? { "data-testid": testId } : {})}>
      {label}
    </MUIButton>
  );
};

export default Button;
